import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'
import { Trip } from '@types'

interface TripsResponse {
	trips: Trip[]
}

interface UseTripsOptions {
	/**
	 * Pass `false` while there is no session: the authenticated client answers a
	 * 401 by clearing the session and bouncing to login, which a page that also
	 * serves signed-out visitors (the Join page) must never trigger.
	 */
	enabled?: boolean
}

export const useTrips = ({ enabled = true }: UseTripsOptions = {}) => {
	return useQuery<TripsResponse>({
		queryKey: queryKeys.trips(),
		queryFn: async () => {
			const response = await api.get<TripsResponse>('/trips')
			return response.data
		},
		retry: 1,
		enabled,
	})
}
